<template>
	<div>
		<h1 class="honour-title">荣誉资质</h1>
		<div class="masonry-container">
			<div class="row">
				<el-image :src="require('../../static/honour/1.jpg')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/2.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/3.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/4.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/13.png')" fit="cover"></el-image>
			</div>
			<div class="row">
				<el-image :src="require('../../static/honour/5.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/6.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/7.jpg')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/8.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/14.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/15.jpg')" fit="cover"></el-image>
			</div>
			<div class="row">
				<el-image :src="require('../../static/honour/9.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/10.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/11.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/12.png')" fit="cover"></el-image>
				<el-image :src="require('../../static/honour/16.jpg')" fit="cover"></el-image>
			</div>
		</div>
	</div>
</template>

<script>
	// import Vue from 'vue'
	// import {VueMasonryPlugin} from 'vue-masonry'
	// Vue.use(VueMasonryPlugin)
	export default {
		name: 'honour',
		data() {
			return {};
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.honour-title {
		margin-top: 25px;
		font-size: 35px;
		font-weight: bold;
		color: #4995DF;
		text-align: center;
	}

	.masonry-container {
		margin-top: 50px;
		display: flex;
		justify-content: center;
	}

	.row {
		flex: 0 0 33.3%;
		display: flex;
		flex-direction: column;
		margin: 0px 0px;
	}

	.el-image {
		width: 372px;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/honour.vue